import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
//import MockService from "@/core/mock/mock.service";
import { VERIFY_AUTH } from "@/core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";


import JwtService from "@/core/services/jwt.service";

import JsonExcel from "vue-json-excel";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import "@/core/plugins/formvalidation";
import VueMask from 'v-mask';
// API service init
ApiService.init();

// Remove this to disable mock API
//MockService.init();


Vue.use(VueMask);

Vue.component('downloadExcel', JsonExcel);


router.beforeEach((to, from, next) => {
  //let storeVar = store;
  const {authorize} = to.meta;

  let authorized =  String(to.meta.authorize);
  let authorizedRoles = new Array();
  authorizedRoles = authorized.split(',');

  
  // Ensure we checked auth before each page load.
  Promise.all([store.dispatch(VERIFY_AUTH)]).then(()=>{
   
    //!Obtener los roles del usuaior
    let roles = JwtService.getRoles();
    
    //?Validar que la ruta requiera autorizacion
    if (authorize) {
    //?Validar que existan roles asignados al usuario
   
     if(roles){

        //?Validar que los roles asignados al usuario estén en los roles que requiere la ruta
        if(!authorizedRoles.some(item => roles.includes(item))){
          return next({ path: '/unauthorized' });
        } 

      } else {
        return next({ path: '/login' });
      }
    } 
    //?Validar que la ruta solicitada sea login
    if(to.path === '/login'){

      //Si existen roles, redirigir a su página principal
      if(roles){
        if (roles.includes(6)) {
          return next({ name: "dashboard" });
        }
        else if (roles.includes(1)) {
          return next({ name: "dashboard-master-instituciones" });
        }
        //Si es aprobador o revisor
        else if (roles.includes(2) || this.currentRoles.includes(3)) {
          return next({ name: "dashboard-revisor-aprobador" });
        }
        //Si es informador municipal
        else if (roles.includes(4)) {
          return next({ name: "dashboard-informador" });
        }
        //Si es creador departamental
        else if (roles.includes(5)) {
          return next({ name: "dashboard-creador" });
        } 
      }

      next()
    }
      next()

  });

  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
